import * as types from "./actionTypes";

export const removeAlert = () => {
  return {
    type: types.REMOVE_ALERT,
  };
};
